/**
 * Unfortunately Typescript is lacking a native construct to declare static methods in abstract classes
 * or interfaces. That feature would allow to make static factory methods when we need multiple
 * constructors with different signatures (which by the way is also not supported by TS).
 * This function offers a workaround: it can be used as a Typescript annotation to hint the compiler
 * that we are implementing all the (non-static) methods from an interface as static methods.
 * 
 * For the actual code that insipired this workaround:
 * @see https://stackoverflow.com/questions/13955157/how-to-define-static-property-in-typescript-interface
 *
 * For a much cleaner way that may be implemented in Typescript in the future:
 * @see https://github.com/microsoft/TypeScript/issues/33892
 * @see https://github.com/microsoft/TypeScript/issues/34516
 */

export function staticImplements<T>(): <U extends T>(constructor: U) => void
{
    return <U extends T>(constructor: U) => { constructor };
}
